<template>
  <div class="app-carousel">
    <hooper 
      group="group1" 
      ref="primary"
      :wheel-control="false"
      @slide="updatePrimaryCarousel($event)"
      class="app-carousel__carousel app-carousel__carousel--primary"
    >
      <slide 
        v-for="(slide, index) in slides" 
        :key="index" 
        class="app-carousel__slide"
        center-mode
        infinite-scroll
        trim-white-space
        ref="slides"
      >
        <img 
          :src="slide.url"
          alt="Project thumbnail"
          class="app-carousel__image"
          loading="lazy"
        />

        <section class="app-carousel__backdrop-text" v-if="backdropContent">
          <h1>{{ slide.customMetadata.title }}</h1>
          <p>{{ slide.customMetadata.text }}</p>
          <span>Fotógrafo - {{ slide.customMetadata.creator }}</span>
        </section>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>

    <hooper 
      group="group2" 
      ref="secondary" 
      class="app-carousel__carousel app-carousel__carousel--secondary" 
      :wheel-control="false" 
      @slide="updateCarousel($event)"
      center-mode
    >
      <slide v-for="(item, index) in items" :key="index">
        <section class="app-carousel__text-content">
          <h2>{{ item.label }}</h2>
        </section>
      </slide>

      <hooper-navigation slot="hooper-addons" class="hooper-navigation--small"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
  export default {
    name: 'AppCarousel',

    components: {
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination
    },

    props: {
      items: {
        type: Array,
        default: () => ([])
      },
      slides: {
        type: Array,
        default: () => ([])
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      backdropContent: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      currentIndex: 0,
      primarySlideFromIndex: 0,
      timerId: null,
      init: false
    }),

    mounted() {
      this.init = true
    },

    beforeDestroy() {
      clearTimeout(this.timerId)
    },

    watch: {
      currentIndex: {
        handler(value) {
          this.init = true
          this.$refs.primary.slideTo(0)
          this.$emit('fetch-photos',`DÍA ${ value }`)
        }
      },
      primarySlideFromIndex: {
        handler(value) {
          if ( value )
            clearTimeout(this.timerId)
        }
      },
      init: {
        handler(value) {
          if ( value )
            this.initCarousel()
        }
      }
    },
    
    methods: {
      updateCarousel(payload) {
        this.currentIndex = payload.currentSlide + 1
      },
      updatePrimaryCarousel(payload) {
        this.getElement(payload.currentSlide)
        this.primarySlideFromIndex = payload.slideFrom
      },
      getElement(index) {
        if ( Array.isArray(this.$refs.slides) ) {
          const ref = this.$refs.slides[index]
          
          this.clearActiveClass(ref.$el)
        }
      },
      clearActiveClass(el = null) {
        if ( this.init ) {
          el = document.querySelector('.is-active')
          this.init = false //- set `init` to false to not run this if statement again after first mount
        }

        if ( !el )
          return

        this.timerId = setTimeout(() => {
          el.classList.remove('is-active')
        }, 10000);
      },
      initCarousel() {
        setTimeout(() => {
          this.clearActiveClass()
        }, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-carousel {
    $root: &;

    margin-top: 4rem;

    &__carousel {
      width: 100%;

      &--primary {
        height: 90vh;
      }

      &--secondary {
        height: auto;
        width: 100%;
        max-width: 350px;
        margin: auto;
      }
    }

    &__slide {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, .1);
      }

      &.is-active {
        #{$root}__backdrop-text {
          opacity: 1;
          visibility: visible;
          transform: translateX(0);
        }
      }
    }

    &__image {
      height: 100vh;
      width: 100%;
      object-fit: cover;
      object-position: top center;

    }

    &__backdrop-text {
      position: absolute;
      bottom: 3rem;
      right: 0;
      width: 100%;
      padding: 1.5rem 2rem 3rem;
      backdrop-filter: blur(2px);
      background-color: rgba(#fff, .75);
      opacity: 0;
      visibility: hidden;
      transform: translateX(-100%);
      transition: opacity .5s, visibility .5s, transform .5s ease 1s;
      
      h1 {
        width: 100%;
        margin-bottom: .5rem;
        font-size: clamp(2rem, 4vw, 2rem);
        
        @media (min-width: 768px) {
          width: 50%;
        }
      }
      
      p {
        width: 100%;
        line-height: 1.4;
        font-size: clamp(.9rem, 4vw, 1.05rem);
      }

      span {
        position: absolute;
        bottom: 0;
        left: 1.5rem;
        padding: .5rem;
        font-size: .7rem;
        font-style: italic;
      }

      &::before {
        content: "";
        height: 100%;
        width: 6px;
        left: 0;
        top: 0;
        display: block;
        position: absolute;
        background-color: #289EA8;
      }
      
      @media (min-width: 1660px) {
        left: 0;
        width: 65%;
        border-radius: 0 4px 4px 0;
      }
    }

    &__text-content {
      text-align: center;
      padding: 2rem 0;

      h2 {
        font-weight: 100;
      }
    }
  }
</style>